import { BrowserAction } from "../../Reducers/Client/Browser"
import { BrowserType } from "../Types"

export const acceptCalibrationJobs = (instanceID: string): BrowserAction => ({
    type: BrowserType.acceptCalibrationJob,
    meta: {
        instanceID
    }
})
